import { Container } from 'components/Container/Container';
import { ContainerWrapper } from 'components/ContainerWrapper/ContainerWrapper';
import { Header } from 'components/Header/Header';
import { RangeContainer } from 'components/RangeContainer/RangeContainer';
import { GraphContainer } from 'components/GraphContainer/GraphContainer';

export const App = () => {
  return (
    <Container>
      <Header />
      <ContainerWrapper>
        <RangeContainer />
        <GraphContainer />
      </ContainerWrapper>
    </Container>
  );
};
